import lodash from 'lodash';
import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { getLeadsDivisions } from '../../../Manage_retail/requests/get_leads_divisions_request';

function* getCatalogs() {
    yield put({
        type: 'SET_LEAD_CREATE_DATA',
        payload: {
            catalogs: {
                lead_source: {
                    loading: true,
                    data: [],
                },
            },
        },
    });

    const store = yield select();
    const userDivisions = lodash.get(store, 'App.App_content.user.divisions') || [];
    const divisionsIds = userDivisions.map(division => division._id);

    const { options } = yield call(getLeadsDivisions, divisionsIds);

    yield put({
        type: 'SET_LEAD_CREATE_DATA',
        payload: {
            catalogs: {
                lead_source: {
                    loading: true,
                    data: options,
                },
            },
        },
    });
}

export default function* getCreateLeadcatalogsSaga() {
    yield takeEvery('GET_LEAD_CREATE_CATALOGS_SAGA', getCatalogs);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/sagas/getCatalogs.saga.js